export const YANDEX_METRIKA_COUNTER_ID = 25804853

const YANDEX_METRIKA_SCRIPT_URL = 'https://mc.yandex.ru/metrika/tag.js'
const YANDEX_METRIKA_SCRIPT_ID = 'yandex-metrika-tag'
const APP_ORIGIN = 'https://mobileapp.mcbuy.ru'
const GLOBAL_STATE_KEY = '__mcbuyYandexMetrikaState'
const DEFAULT_TITLE = 'Marc Cain'

const ROUTE_TITLES = Object.freeze({
  main: 'Главная',
  detail: 'Карточка товара',
  order_success: 'Спасибо за заказ',
  blog_detail: 'Статья блога',
  page: 'Информация',
  notfound: 'Ошибка'
})

function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}

function getGlobalState() {
  if (!window[GLOBAL_STATE_KEY]) {
    window[GLOBAL_STATE_KEY] = {
      initialized: false,
      lastVirtualUrl: null,
      routerHooks: new WeakMap()
    }
  }

  return window[GLOBAL_STATE_KEY]
}

function logDevelopmentError(message, error) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(`[Yandex Metrika] ${message}`, error || '')
  }
}

function ensureYmQueue() {
  if (typeof window.ym === 'function') {
    return
  }

  const ym = function () {
    (ym.a = ym.a || []).push(arguments)
  }

  ym.l = Date.now()
  window.ym = ym
}

function ensureMetrikaScript() {
  const scriptAlreadyAdded = Array.from(document.scripts).some((script) => {
    return script.src === YANDEX_METRIKA_SCRIPT_URL
  })

  if (scriptAlreadyAdded) {
    return
  }

  const script = document.createElement('script')
  script.id = YANDEX_METRIKA_SCRIPT_ID
  script.async = true
  script.src = YANDEX_METRIKA_SCRIPT_URL
  script.onerror = (error) => {
    logDevelopmentError('не удалось загрузить tag.js', error)
  }

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

function buildVirtualUrl(path) {
  const safePath = typeof path === 'string' && path.startsWith('/') ? path : '/'
  return new URL(safePath, APP_ORIGIN).toString()
}

function sanitizeReferrer(referrer) {
  if (!referrer) {
    return ''
  }

  try {
    const url = new URL(referrer)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return ''
    }

    return `${url.origin}${url.pathname}`
  } catch (error) {
    logDevelopmentError('не удалось обработать referrer', error)
    return ''
  }
}

function getRouteTitle(route) {
  const metaTitle = route && route.meta && (route.meta.name || route.meta.title)
  if (typeof metaTitle === 'string' && metaTitle.trim()) {
    return metaTitle.trim()
  }

  const routeName = route && typeof route.name === 'string' ? route.name : ''
  return ROUTE_TITLES[routeName] || DEFAULT_TITLE
}

function callYm(...args) {
  if (!isBrowser()) {
    return false
  }

  ensureYmQueue()

  try {
    window.ym(YANDEX_METRIKA_COUNTER_ID, ...args)
    return true
  } catch (error) {
    logDevelopmentError('ошибка вызова API', error)
    return false
  }
}

export function installYandexMetrika() {
  if (!isBrowser()) {
    return false
  }

  const state = getGlobalState()
  window.dataLayer = window.dataLayer || []
  ensureYmQueue()
  ensureMetrikaScript()

  if (state.initialized) {
    return true
  }

  const initialUrl = buildVirtualUrl(window.location.pathname)
  const initialReferrer = sanitizeReferrer(document.referrer)

  state.initialized = true
  return callYm('init', {
    defer: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: initialReferrer,
    url: initialUrl,
    accurateTrackBounce: true,
    trackLinks: true
  })
}

export function hit(url, options = {}) {
  installYandexMetrika()
  return callYm('hit', url, options)
}

export function reachGoal(target, params = {}) {
  if (typeof target !== 'string' || !target.trim()) {
    logDevelopmentError('не задан идентификатор цели')
    return false
  }

  installYandexMetrika()
  return callYm('reachGoal', target, params)
}

export function installYandexMetrikaRouterTracking(router) {
  if (!isBrowser() || !router || typeof router.afterEach !== 'function') {
    return false
  }

  installYandexMetrika()

  const state = getGlobalState()
  if (state.routerHooks.has(router)) {
    return true
  }

  const removeHook = router.afterEach((to, from, failure) => {
    if (failure) {
      return
    }

    const virtualUrl = buildVirtualUrl(to.path)
    const title = getRouteTitle(to)
    const referrer = state.lastVirtualUrl || sanitizeReferrer(document.referrer)
    const options = { title }

    if (referrer) {
      options.referer = referrer
    }

    document.title = title
    hit(virtualUrl, options)
    state.lastVirtualUrl = virtualUrl
  })

  state.routerHooks.set(router, removeHook)
  return true
}

